import { render, staticRenderFns } from "./ShortBySenders.vue?vue&type=template&id=342b9f5b&scoped=true&"
import script from "./ShortBySenders.vue?vue&type=script&lang=js&"
export * from "./ShortBySenders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342b9f5b",
  null
  
)

export default component.exports